import React, { useState } from "react";
import { generateBulkInvoicePDF } from "../../afinanceapi";
import { Modal, Button, Form, Row, Col, Alert } from "react-bootstrap";
import AppToast from "../Toasts/AppToast";
import { useToast } from "../Toasts/useToast";

function BulkExportModal({ show, onHide, onGenerate, accountId }) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [includeInvoices, setIncludeInvoices] = useState(false);
  const [includeReceipts, setIncludeReceipts] = useState(false);
  const [includeStatement, setIncludeStatement] = useState(false);
  const [error, setError] = useState("");
  const { toast, showToast, hideToast } = useToast();

 async function handleGenerate() {
  if (!startDate || !endDate) {
    setError("Please select both start and end dates.");
    return;
  }

  if (!includeInvoices && !includeReceipts && !includeStatement) {
    setError("Please select at least one export option.");
    return;
  }

  setError("");

  try {
    let response = await generateBulkInvoicePDF(accountId, startDate, endDate, {
      includeInvoices,
      includeReceipts,
      includeStatement,
    });
    if (response.status === 404) {
      setError("No data found for the selected date range.");
      return;
    }

    showToast("success", "Bulk export started! You will be notified when it's ready.");
    onHide();
    resetState();
  } catch (err) {
    console.error("Failed to generate bulk PDF:", err);
    setError("Failed to start bulk export. Please try again.");
  }
}

  const resetState = () => {
    setStartDate("");
    setEndDate("");
    setIncludeInvoices(false);
    setIncludeReceipts(false);
    setIncludeStatement(false);
    setError("");
  };

  return (
    <>
    <Modal show={show} onHide={() => { onHide(); resetState(); }} centered>
      <Modal.Header>
        <Modal.Title className="text-primary">Bulk Export</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Alert variant="danger" className="fw-normal fs-6">
            {error}
          </Alert>
        )}
        <Form>
          <Row className="mb-1">
            <p className="text-muted">Multiple Invoices and Receipts can be exported in bulk between the set dates. These will be exported in a single document.</p>
          </Row>
          <Row className="mb-3">
            <Col>
              <Form.Label className="text-primary fw-semibold">Start Date</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Col>
            <Col>
              <Form.Label className="text-primary fw-semibold">End Date</Form.Label>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Col>
          </Row>
          <Form.Label className="fw-semibold text-primary">Export Options</Form.Label>
          <Form.Group className="mb-3 ms-3">
            <Form.Check
              type="checkbox"
              label="Invoices"
              checked={includeInvoices}
              onChange={(e) => setIncludeInvoices(e.target.checked)}
            />
            <Form.Check
              type="checkbox"
              label="Receipts"
              checked={includeReceipts}
              onChange={(e) => setIncludeReceipts(e.target.checked)}
            />
          {/*}  <Form.Check
              type="checkbox"
              label="Account Statement"
              checked={includeStatement}
              onChange={(e) => setIncludeStatement(e.target.checked)}
            /> */}
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary w-25"
          onClick={() => {
            onHide();
            resetState();
          }}
        >
          Close
        </Button>
        <Button variant="primary w-25" onClick={handleGenerate}>
          Generate
        </Button>
      </Modal.Footer>
    </Modal>
    <AppToast
      show={toast.show}
      onClose={hideToast}
      variant={toast.variant}
      message={toast.message}
    />
    </>
  );
}

export default BulkExportModal;
